import { render, staticRenderFns } from "./BoxesOverviewStatus.vue?vue&type=template&id=b5a3b924"
import script from "./BoxesOverviewStatus.vue?vue&type=script&lang=js"
export * from "./BoxesOverviewStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports